/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeleteUserEligibilityReasonDto } from './deleteUserEligibilityReasonDto';


export interface DeleteUserBlockedResponseDto { 
    canDelete: boolean;
    blocked: boolean;
    blockers: Array<DeleteUserEligibilityReasonDto>;
    warnings: Array<DeleteUserEligibilityReasonDto>;
    error: DeleteUserBlockedResponseDto.ErrorEnum;
}
export namespace DeleteUserBlockedResponseDto {
    export type ErrorEnum = 'delete_user_blocked';
    export const ErrorEnum = {
        DeleteUserBlocked: 'delete_user_blocked' as ErrorEnum
    };
}


